///ts:ref=Browser
/// <reference path="./Browser.ts"/> ///ts:ref:generated
class BrowserSpecific { 
	private static _hasStackOnUnthrowedError:boolean = null;
	public static hasStackOnUnthrowedError():boolean {
		if (BrowserSpecific._hasStackOnUnthrowedError === null) {
			BrowserSpecific._hasStackOnUnthrowedError = Browser.isChrome() || Browser.isFireFox() || Browser.isEdge() || Browser.isOldOpera() || Browser.isSafari();
		}
		return BrowserSpecific._hasStackOnUnthrowedError;
	}

	private static _errorHasExtenderConstructorLine:boolean = null;
	public static errorHasExtenderConstructorLine():boolean {
		if (BrowserSpecific._errorHasExtenderConstructorLine === null) {
			BrowserSpecific._errorHasExtenderConstructorLine = !Browser.isOldOpera();
		}
		return BrowserSpecific._errorHasExtenderConstructorLine;
	}

	private static _errorStackHasNoClass:boolean = null;
	public static errorStackHasNoClass():boolean {
		if (BrowserSpecific._errorStackHasNoClass === null) {
			BrowserSpecific._errorStackHasNoClass = Browser.isSafari() || Browser.isIos();
		}
		return BrowserSpecific._errorStackHasNoClass;
	}

	private static _colorsInConsole:boolean = null;
	public static colorsInConsole():boolean {
		if (BrowserSpecific._colorsInConsole === null) {
		  BrowserSpecific._colorsInConsole = Browser.isChrome() || Browser.isFireFox();
		}
		return BrowserSpecific._colorsInConsole;
	}

	private static _inconsistenceUserAgent:boolean = null; // у IE 11 юзер агент который он отдаёт при запросах не содержит .NET комментов
	public static inconsistenceUserAgent():boolean {
		if (BrowserSpecific._inconsistenceUserAgent === null) {
			BrowserSpecific._inconsistenceUserAgent = Browser.isIe();
		}
		return BrowserSpecific._inconsistenceUserAgent;
	}

	private static _functionHoistingBug:boolean = null;
	public static functionHoistingBug():boolean {
		if (BrowserSpecific._functionHoistingBug === null) {
			let version = Math.floor(Browser.getInfo().versionNumber);
			BrowserSpecific._functionHoistingBug = Browser.isFireFox() && version >= 42 && version <= 45;
		}
		return BrowserSpecific._functionHoistingBug;
	}

	private static _unhandledErrorHasNoCol:boolean = null;
	public static unhandledErrorHasNoCol():boolean {
		if (BrowserSpecific._unhandledErrorHasNoCol === null) {
			BrowserSpecific._unhandledErrorHasNoCol = Browser.isOldOpera()  || (Browser.isIe() && Browser.getInfo().versionNumber < 11);
		}
		return BrowserSpecific._unhandledErrorHasNoCol;
	}

	private static _unhandledErrorBug:boolean = null;
	public static unhandledErrorBug():boolean {
		if (BrowserSpecific._unhandledErrorBug === null) {
			BrowserSpecific._unhandledErrorBug = Browser.isEdge() || Browser.isSafari() || Browser.isIos() || Browser.isOldOpera() || (Browser.isIe() && Browser.getInfo().versionNumber < 11);
		}
		return BrowserSpecific._unhandledErrorBug;
	}

	private static _onlyExperimentalWebGL:boolean = null;
	public static onlyExperimentalWebGL():boolean {
		if (BrowserSpecific._onlyExperimentalWebGL === null) {
			BrowserSpecific._onlyExperimentalWebGL = Browser.isEdge() || Browser.isIe();
		}
		return BrowserSpecific._onlyExperimentalWebGL;
	}

	private static _disabledWebGLDebugRendererInfo:boolean = null;
	public static disabledWebGLDebugRendererInfo():boolean {
		if (BrowserSpecific._disabledWebGLDebugRendererInfo === null) {
			BrowserSpecific._disabledWebGLDebugRendererInfo = Browser.isFireFox() || Browser.isIos();
		}
		return BrowserSpecific._disabledWebGLDebugRendererInfo;
	}

	private static _XDomainRequestNeeded:boolean = null;
	public static XDomainRequestNeeded():boolean {
		if (BrowserSpecific._XDomainRequestNeeded === null) {
			BrowserSpecific._XDomainRequestNeeded = Browser.isIe() && (Math.floor(Browser.getInfo().versionNumber) === 8 || Math.floor(Browser.getInfo().versionNumber) === 9);
		}
		return BrowserSpecific._XDomainRequestNeeded;
	}

	private static _noEventInHandlers:boolean = null;
	public static noEventInHandlers():boolean {
		if (BrowserSpecific._noEventInHandlers === null) {
			BrowserSpecific._noEventInHandlers = Browser.isIe() && Math.floor(Browser.getInfo().versionNumber) <= 9;
		}
		return BrowserSpecific._noEventInHandlers;
	}

	private static _scrrenSizeSupported:boolean = null;
	public static scrrenSizeSupported():boolean {
		if (BrowserSpecific._scrrenSizeSupported === null) {
			if (window.screen && typeof window.screen.width === 'number') {
				BrowserSpecific._scrrenSizeSupported = true;
			} else {
				BrowserSpecific._scrrenSizeSupported = false;
			}
		}
		return BrowserSpecific._scrrenSizeSupported;
	}
}